import { CommonKeys } from "../../../common/enums";
import type { StammElement } from "./StammElement";

export const STAMM_ANLAGE_TYPE = "AM_Services.Domain.Models.Formulare.StammElementAnlage, AM_Services.Domain.Standard";

export const FormularGroupStammStammElementAnlageSchema = {
    $id: "FormularGroupStammStammElementAnlageSchema",
    title: "FormularGroupStammStammElementAnlage Schema",
    type: "object",
    allOf: [
        { $ref: "FormularGroupStammStammElementBaseSchema" },
        {
            type: "object",
            properties: {
                [CommonKeys.Type]: { const: STAMM_ANLAGE_TYPE },
                Property: { type: "number", nullable: true }
            }
        }
    ],
};

export interface StammElementAnlage extends StammElement {
    Property: StammElementAnlageProperty
}

export enum StammElementAnlageProperty {
    NrIntern, NrExtern, Standort, NrBeide
}